<template>
    <form-container :title="stageTitle">
    <form-declaration :display="0"></form-declaration>
    <label class="check-container">I have read and understood the above on Data Protection.
        <input type="checkbox" v-model="agreeDataProtection">
        <span class="check-checkmark"></span>
    </label>
    <div
        v-if="!isDPValid && nextAttempted"
        class="text-danger">
        <small>Please indicate that you have read and understood by checking the box</small>
    </div>
    <hr />
    <form-declaration :display="1"></form-declaration>
    <label class="check-container">I have read and understood the above on Fradulent Claims.
        <input type="checkbox" v-model="agreeFraud" >
        <span class="check-checkmark"></span>
    </label>
    <div
        v-if="!isFRValid && nextAttempted"
        class="text-danger">
        <small>Please indicate that you have read and understood by checking the box</small>
    </div>
    <hr />
    <form-declaration :display="2"></form-declaration>
    <label class="check-container">I have read, understood and confirm the above.
        <input type="checkbox" v-model="agreeDeclaration">
        <span class="check-checkmark"></span>
    </label>
    <div
        v-if="!isDCValid && nextAttempted"
        class="text-danger">
        <small>Please indicate that you have read and understood by checking the box</small>
    </div>
    <br />
    <form-button-bar
            :back_button_enable='true'
            :back_button_show='true'
            :back_button_icon_enable='true'
            :back_button_action='() => $router.go(-1)'
            :next_button_enable='true'
            :next_button_show='true'
            :next_button_icon_enable='true'
            :next_button_action='handleNextClick' />
</form-container>
</template>

<script>

import tigaClaimForm from '@/mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'
import FormDeclaration from '@/components/FormDeclaration.vue'

export default {
  name: 'declaration',
  components: {
    FormContainer,
    FormDeclaration,
    FormButtonBar
  },
  mixins: [
    tigaClaimForm
  ],
  data () {
    return {
      nextAttempted: false
    }
  },
  mounted () {
    //console.log("Mounted")
    if (!this.claimformHasPolicyNumber || 
      !this.claimformHasClaimant || 
      !this.claimformHasIncidentType || 
      !this.claimformHasClaimantUKRes ||
      !this.claimformHasClaimantVATReg ||
      !this.claimformHasIncidentDetails ||
      !this.claimformHasGadgets) {
      this.gotoStage1();
    }
  },
  watch: {

  },
  computed: {
    agreeDataProtection: {
      get () {
        return this.$store.state.claimform.claimForm.data.agreeDataProtection
      },
      set (value) {
        this.$store.commit('claimform/setAgreeDataProtection', { agreeDataProtection: value })
      }
    },
    agreeFraud: {
      get () {
        return this.$store.state.claimform.claimForm.data.agreeFraud
      },
      set (value) {
        this.$store.commit('claimform/setAgreeFraud', { agreeFraud: value })
      }
    },
    agreeDeclaration: {
      get () {
        return this.$store.state.claimform.claimForm.data.agreeDeclaration
      },
      set (value) {
        this.$store.commit('claimform/setAgreeDeclaration', { agreeDeclaration: value })
      }
    },
    isDPValid () {
      return this.agreeDataProtection == true
    },
    isFRValid () {
      return this.agreeFraud == true
    },
    isDCValid () {
      return this.agreeDeclaration == true
    },
    isFormValid () {
      if (!this.isDPValid) {
        return false
      }

      if (!this.isFRValid) {
        return false
      }

      if (!this.isDCValid) {
        return false
      }

      return true
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    handleNextClick () {
      this.nextAttempted = true

      if (this.isFormValid) {
        this.$router.push({ path: '17' })
      }
    }
  }
}
</script>

<style>

</style>
